import './MeterBarPlot.css';
export var svgElement = '_1ix39sy0-2-0-1';